"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var abstract_geocoder_1 = __importDefault(require("./abstract-geocoder"));
var hereResultTypeToPeliasLayerMap = {
    houseNumber: "address",
    place: "venue"
};
var convertHereToGeojson = function (hereFeature) {
    var scoring = hereFeature.scoring, categories = hereFeature.categories, address = hereFeature.address, resultType = hereFeature.resultType, title = hereFeature.title, position = hereFeature.position;
    var extraFields = {};
    if (scoring) {
        extraFields.confidence = scoring.queryScore;
    }
    if (categories) {
        extraFields.addendum = {
            categories: categories
        };
    }
    return {
        geometry: {
            type: "Point",
            coordinates: [position.lng, position.lat]
        },
        properties: __assign(__assign({ country: address.countryName, country_a: address.countryCode, country_code: address.countryCode, county: address.county, housenumber: address.houseNumber, label: address.label, layer: hereResultTypeToPeliasLayerMap[resultType]
                ? hereResultTypeToPeliasLayerMap[resultType]
                : resultType }, extraFields), { locality: address.city, name: title, neighbourhood: address.district, postalcode: address.postalCode, region: address.state, source: "here", street: address.street }),
        type: "Feature"
    };
};
var HereGeocoder = /** @class */ (function (_super) {
    __extends(HereGeocoder, _super);
    function HereGeocoder() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    HereGeocoder.prototype.rewriteReverseResponse = function (_a) {
        var _b;
        var items = _a.items, point = _a.point;
        if ((_b = this.geocoderConfig) === null || _b === void 0 ? void 0 : _b.reverseUseFeatureCollection) {
            return {
                features: items.map(convertHereToGeojson),
                type: "FeatureCollection",
            };
        }
        // Render the result as a single geocoder response
        var firstItem = items[0];
        return __assign(__assign({}, point), { name: firstItem.title, rawGeocodedFeature: convertHereToGeojson(firstItem) });
    };
    HereGeocoder.prototype.rewriteAutocompleteResponse = function (response) {
        var items = response.items;
        return {
            features: items === null || items === void 0 ? void 0 : items
            // Here has various types of responses, some of which are not locations.
            // We only want the actual places, so throw out any without a position.
            .filter(function (item) { return !!item.position; }).map(convertHereToGeojson),
            type: "FeatureCollection"
        };
    };
    HereGeocoder.prototype.rewriteSearchResponse = function (_a) {
        var items = _a.items;
        return {
            features: items.map(convertHereToGeojson),
            type: "FeatureCollection"
        };
    };
    return HereGeocoder;
}(abstract_geocoder_1.default));
exports.default = HereGeocoder;
//# sourceMappingURL=here.js.map